var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.666H11.9998V13.3327C11.9998 12.2281 11.1044 11.3327 9.99984 11.3327H5.99984C4.89527 11.3327 3.99984 12.2281 3.99984 13.3327V14.666H2.6665V13.3327C2.6665 11.4917 4.15889 9.99935 5.99984 9.99935H9.99984C11.8408 9.99935 13.3332 11.4917 13.3332 13.3327V14.666ZM7.99984 8.66602C5.7907 8.66602 3.99984 6.87515 3.99984 4.66602C3.99984 2.45688 5.7907 0.666016 7.99984 0.666016C10.209 0.666016 11.9998 2.45688 11.9998 4.66602C11.9998 6.87515 10.209 8.66602 7.99984 8.66602ZM7.99984 7.33268C9.47257 7.33268 10.6665 6.13878 10.6665 4.66602C10.6665 3.19326 9.47257 1.99935 7.99984 1.99935C6.52708 1.99935 5.33317 3.19326 5.33317 4.66602C5.33317 6.13878 6.52708 7.33268 7.99984 7.33268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/change-password-icon.95eb5253927500c39f054e0d86b64eb8.svg";
export { ForwardRef as ReactComponent };